import Image from "next/image";
import AuthFooter from "@/components/auth/auth-footer";

interface AuthLayoutProps {
  children: React.ReactNode;
  className?: string;
  contentClassName?: string;
  showFooter?: boolean;
}

const AuthLayout: React.FC<AuthLayoutProps> = ({
  children,
  className,
  contentClassName,
  showFooter = true,
}) => {
  const mainClassName = [
    "relative min-h-screen flex flex-col items-center justify-center gap-5",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const contentWrapperClassName = ["relative z-10 w-full", contentClassName]
    .filter(Boolean)
    .join(" ");

  return (
    <main className={mainClassName}>
      <div className="fixed inset-0 -z-10">
        <Image
          src="/images/login/bg-screen.png"
          alt="ReEquip auth background"
          fill
          priority
          sizes="100vw"
          className="object-cover object-center"
          aria-hidden="true"
        />
        {/* Overlay */}
        <div className="absolute inset-0 bg-gray-900/50 dark:bg-slate-950/80" />
      </div>

      <div className={contentWrapperClassName}>{children}</div>

      {showFooter ? <AuthFooter /> : null}
    </main>
  );
};

export default AuthLayout;
